import { render, staticRenderFns } from "./CompanyBankruptcyProfile.vue?vue&type=template&id=3c699091"
import script from "./CompanyBankruptcyProfile.vue?vue&type=script&lang=js"
export * from "./CompanyBankruptcyProfile.vue?vue&type=script&lang=js"
import style0 from "./CompanyBankruptcyProfile.vue?vue&type=style&index=0&id=3c699091&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports